import Image from 'next/image';
import React from 'react';

function CreatrReview() {
  return (
    <div className="w-full h-full relative rounded-lg overflow-hidden">
      <Image
        src="https://assets.getcreatr.com/sign-up/creatr-review.svg"
        alt="Creatr Review"
        className="object-contain w-full h-[calc(100vh-48px)]"
        height={500}
        width={500}
      />
    </div>
  );
}

export default CreatrReview;
